module.exports = __webpack_public_path__ + "img/logout.517b9bc0.svg";